import { render } from "./AboutSlider.vue?vue&type=template&id=79da7d06&scoped=true"
import script from "./AboutSlider.vue?vue&type=script&lang=js"
export * from "./AboutSlider.vue?vue&type=script&lang=js"

import "./AboutSlider.vue?vue&type=style&index=0&id=79da7d06&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79da7d06"]])

export default __exports__